import { GlobalStyle } from '../GlobalStyle';
import { AppProvider } from 'foundations-components/components/AppProvider';
import { AlertProvider } from '../Alerts/AlertProvider';
import { BreezeGradients } from './BreezeGradients';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BreezeIntelligenceKitProviderNext = ({
  children
}) => {
  return /*#__PURE__*/_jsxs(AlertProvider, {
    children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsx(BreezeGradients, {}), children]
  });
};
/**
 * Eventually we can sunset this provider and just use the BreezeIntelligenceKitProviderNext
 * since apps will have AppProvider or ThemeProvider
 * @deprecated Use BreezeIntelligenceKitProviderNext unless there are apps or call sites
 * that don't have AppProvider or ThemeProvider
 */
export const BreezeIntelligenceKitProvider = ({
  children
}) => {
  return /*#__PURE__*/_jsx(AppProvider, {
    children: /*#__PURE__*/_jsx(BreezeIntelligenceKitProviderNext, {
      children: children
    })
  });
};